function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global) {
  "use strict";

  angular.module("wsLrs.services").
  /**
   * A service that wraps $http to send to the elasticsearch backend service
   */
  factory('QueryES', ['$http', 'Api', 'Demo', 'QueryWithProgress', 'ShareUtils', '$location', function ($http, Api, Demo, QueryWithProgress, ShareUtils, $location) {
    function post(configuration, endpoint) {
      endpoint = endpoint || "";
      return $http.post(Api.url("/query" + endpoint), configuration);
    }
    function get(configuration, endpoint) {
      endpoint = endpoint || "";
      return $http.get(Api.url("/query" + endpoint), {
        params: {
          request: configuration
        }
      });
    }
    function shouldPost(configuration, alwaysPost) {
      if (alwaysPost) {
        return true;
      }
      if (JSON.stringify(configuration).length < 1900) {
        return false;
      } else {
        return true;
      }
    }
    function send(configuration, alwaysPost, endpoint) {
      alwaysPost = alwaysPost || false;
      if (shouldPost(configuration, alwaysPost)) {
        return post(configuration, endpoint);
      } else {
        return get(configuration, endpoint);
      }
    }
    return {
      query: function query(configuration, alwaysPost) {
        return send(configuration, alwaysPost);
      },
      queryWithProgress: function queryWithProgress(configurations) {
        var urls = _.map(configurations, function (cfg) {
          return Api.url("/query") + "?request=" + encodeURIComponent(JSON.stringify(cfg));
        });
        return QueryWithProgress.fetch(urls);
      },
      count: function count(configuration, alwaysPost) {
        return send(configuration, alwaysPost, "/count");
      },
      queryExportUrl: function queryExportUrl(cardIdOrConfig, isCsv, name) {
        var cardConfig = null,
          cardId = null;
        if (_typeof(cardIdOrConfig) !== 'object') {
          cardId = cardIdOrConfig;
        } else {
          cardConfig = cardIdOrConfig;
        }
        var type = isCsv ? "csv" : "json";
        var path = "";
        if (ShareUtils.hasShareKey()) {
          path += "shared/" + ShareUtils.getShareKey() + "/organizations/";
          path += ShareUtils.getCachedShare().card.organization.id;
          path += "/export?shareKey=" + ShareUtils.getShareKey() + (name ? "&name=" + name : "");
          return Api.url(path, true);
        }
        path += "/query/";
        path += "export?type=" + type + (name ? "&name=" + name : "");
        if (cardId) {
          path += "&cardId=" + cardId;
        }
        if (cardConfig) {
          path += "&cardConfig=" + encodeURIComponent(JSON.stringify(cardConfig));
        }
        if ($location.search().filter) {
          path += '&filter=' + encodeURIComponent($location.search().filter);
        }
        if (Demo.isDemoMode()) {
          path += "&demo=true";
        }
        return Api.url(path);
      }
    };
  }]).factory('QueryWithProgress', ['$q', '$rootScope', '$timeout', '$http', 'Logger', 'ShareKeyHelper', 'Utils', function ($q, $rootScope, $timeout, $http, Logger, ShareKeyHelper, Utils) {
    function ProgressAggregator(cfg) {
      this._urls = null;
      this._progressListener = null;
      this._progress = null;
      this.init(cfg);
    }
    ProgressAggregator.prototype = {
      _sum: function _sum(items) {
        return _.reduce(items, function (memo, item) {
          return memo + item;
        });
      },
      init: function init(cfg) {
        this._urls = cfg.urls;
        this._progressListener = cfg.progressListener;
        this._progress = _.object(_.map(this._urls, function (url) {
          return [url, {}];
        }));
      },
      getProgress: function getProgress() {
        return {
          complete: _.every(this._progress, function (p) {
            return p.complete;
          }),
          percent: this._sum(_.pluck(this._progress, "processed")) * 100.0 / this._sum(_.pluck(this._progress, "total"))
        };
      },
      updateProgress: function updateProgress(url, progress) {
        if (!_.contains(this._urls, url)) {
          throw "URL " + url + " was not registered";
        }
        this._progress[url] = progress;
        var aggregateProgress = this.getProgress();
        if (this._progressListener) {
          this._progressListener(aggregateProgress);
        }
        return aggregateProgress;
      }
    };
    var openSources = {},
      nextSourceId = 0,
      _canceler = $q.defer(),
      _requests = [],
      _debounceCache = {};
    function closeOpenSources() {
      _.each(openSources, function (source) {
        source.close();
      });
      openSources = {};
    }
    function nextRequest() {
      var req = _requests.shift();
      if (req) {
        req.resolve();
      }
    }
    function fetchSingleWithProgress(url, progressListener) {
      if (_.isArray(url)) {
        url = url[0];
      }

      // Debounce logic
      var debouncedResult = _debounceCache[url];
      if (debouncedResult) {
        if (new Date().getTime() - debouncedResult.cacheTime < 25) {
          return debouncedResult.promise;
        } else {
          debouncedResult = null;
          delete _debounceCache[url];
        }
      }

      // See if we can just get a cached result through a normal GET request...
      var cachedResultsUrl = Utils.appendParams(url, {
        "requireCached": true
      });
      var req = $q.defer();
      _requests.push(req);
      if (_requests.length === 1) {
        $timeout(function () {
          for (var i = 0; i < 3; i++) {
            nextRequest();
          }
        }, 100);
      }
      var promise = req.promise.then(function () {
        return $http.get(cachedResultsUrl, {
          timeout: _canceler.promise
        });
      }).then(
      // If so, great, we got it and we're done. Score!
      function (response) {
        // We defer the result in order to maintain a consistent
        // timing behavior with fetchSourceWithProgress below
        var future = $q.defer();
        $timeout(function () {
          future.resolve(response.data);
        });
        nextRequest();
        return future.promise;
      },
      // Otherwise, we missed the cache and are going to have to open up an EventSource
      // and wait on the results...
      function (r) {
        if (r.status === -1) {
          return $q.reject('canceled');
        }
        if (r.status === 404) {
          return fetchSourceWithProgress(url, progressListener);
        } else {
          nextRequest();
          return $q.reject(r);
        }
      });
      _debounceCache[url] = {
        promise: promise,
        cacheTime: new Date().getTime()
      };
      return promise;
    }
    function fetchSourceWithProgress(url, progressListener) {
      var source = new global.EventSource(url),
        sourceId = nextSourceId++,
        promiseResolved = false,
        deferred = $q.defer();
      Logger.trace("QueryWithProgress: Opened source " + sourceId);
      openSources[sourceId] = source;
      source.addEventListener("progress", function (evt) {
        if (progressListener) {
          progressListener(JSON.parse(evt.data));
        }
      });
      source.addEventListener("results", function (evt) {
        deferred.resolve(JSON.parse(evt.data));
        promiseResolved = true;
        nextRequest();
      });
      source.addEventListener("error", function (evt) {
        if (evt.data) {
          var err = JSON.parse(evt.data);
          deferred.reject(err.message || "An unexpected error occurred and more information is unavailable at this time.");
          promiseResolved = true;
          nextRequest();
        }
      });

      // The server will close the connection, so we just catch
      // it as an error here (though perfectly normal).
      source.onerror = function () {
        if (source.readyState !== source.OPEN) {
          source.close();
          Logger.trace("QueryWithProgress: Closed source " + sourceId);
          delete openSources[sourceId];
        }

        // If we never actually got to an end through normal means,
        // an unexpected error has occurred.
        if (!promiseResolved) {
          deferred.reject("An unexpected error occurred.");
          promiseResolved = true;
          nextRequest();
        }
      };
      return deferred.promise;
    }
    function fetchWithProgress(urls, progressListener) {
      if (typeof urls === "string" || _.size(urls) === 1) {
        return fetchSingleWithProgress(urls, progressListener);
      }
      var progressAggregator = new ProgressAggregator({
        urls: urls,
        progressListener: progressListener
      });
      var error = null;
      var fetches = _.map(urls, function (url) {
        return fetchSingleWithProgress(url, function (progress) {
          if (!error) {
            progressAggregator.updateProgress(url, progress);
          }
        });
      });
      var promises = $q.all(fetches).then(function (responses) {
        if (_.size(urls) === 1) {
          return responses[0];
        } else {
          return responses;
        }
      });
      return promises.then(function success(result) {
        return result;
      }, function rejected(reason) {
        error = reason;
        return $q.reject(reason);
      });
    }
    function fetchWithProgressEvents(urls, progressChannel) {
      var progressEventPrefix = "report-progress:" + progressChannel,
        startEventName = progressEventPrefix + ":start",
        progressEventName = progressEventPrefix + ":progress",
        errorEventName = progressEventPrefix + ":error";
      $rootScope.$broadcast(startEventName);
      var fetch = fetchWithProgress(urls, function (progress) {
        $rootScope.$safeApply(function () {
          $rootScope.$broadcast(progressEventName, progress);
        });
      });
      return fetch.then(function success(result) {
        return result;
      }, function error(reason) {
        $rootScope.$broadcast(errorEventName, reason);
        return $q.reject(reason);
      });
    }
    return {
      fetch: function fetch(urls, progressChannel) {
        // If we got just a single url, wrap it in an array
        if (typeof urls === "string") {
          urls = [urls];
        }

        // Consider any share context we're in, akin to $http
        var shareKey = ShareKeyHelper.getShareKey();
        if (shareKey) {
          _.each(urls, function (url, index) {
            urls[index] = Utils.appendParams(url, {
              shareKey: shareKey
            });
          });
        }
        return fetchWithProgressEvents(urls, progressChannel);
      },
      cancelOutstanding: function cancelOutstanding() {
        _requests = [];
        closeOpenSources();
        _canceler.resolve();
        _canceler = $q.defer();
      }
    };
  }]);
})(this);
